<template> 
  <div class='px-3 py-3 mb-5 col-24 col-md-11'>
    <div class='col d-column'>
      <h1 class="title pt-2 mb-0">VPN</h1>
      <h1 class="title"><span class="pb-2"></span></h1>  
 
      <div class='card mb-3'>
        <div class='card-header'>
          <h6 class='m-0 p-0 light'>Links de suas VPNs</h6>
        </div> 
        <div class='card-body p-0'>
          <table> 
            <tbody>
              <tr v-if="loading" class="loading"> 
                <div class="c-loader m-3"></div> 
              </tr> 

              <tr v-else-if="!itensCredentials.length" class="d-flex p-3 align-items-center justify-content-center"> 
                <h6 class="mt-1">
                 Nenhuma conexão VPN encontrada
                </h6>
              </tr>
 
              <tr v-for="(item, index) in itensCredentials" :key="index">
                <td class='col-2 justify-content-center d-flex align-items-center'> 
                  <a download="file_vpn.zip" :href="'data:application/zip;base64,'+item.vpn_file" class="pointer"> 
                    <svg width="17" height="17" class="mb-2">
                      <image xlink:href="../../assets/icons/download_vpn.svg" width="18" height="18" />
                    </svg>  
                  </a>  
                </td>

                <td class='col-22'>
                  <div class="row">
                    <p class="mb-0"><strong class="mb-2 mr-3">Programa: <font> {{ item.program_name }}</font></strong> </p> 
                    <VueCustomTooltip :label="!item.online ? 'Offline' : 'Online'">  
                      <span :class="item.online ? 'dot online dot_vpn' : 'dot dot_vpn' "></span>
                    </VueCustomTooltip> 
                  </div>
                  <p class="my-1">  
                    <font class="">Status:  {{item.user_disabled ? 'VPN desativada' : 'VPN ativa' }}</font> 
                  </p>
                  <p class="my-1">  
                    <font>IP: {{ item.virtual_ip }}</font>
                  </p>
                </td> 
              </tr>  
            </tbody> 
          </table> 

          <div v-show="total > 10 && itensCredentials.length" class="p-3">
            <b-pagination v-model="page" :total-rows="total" :per-page="10"
              :prev-text="$ml.get('previous')" :next-text="$ml.get('next')" align="center">
            </b-pagination>
          </div> 
        </div> 
 
      </div> 
    </div> 
  </div> 
</template>

<script>
import ProgramService from "../../services/program.service";
import Swal from "sweetalert2";

export default { 
  data() {
    return {
      itensCredentials: [], 
      loading: true,
      page: 1,
      total: 0,
    };
  },
  mounted() { 
    this.changeSessions(); 
  },
  methods: {
    changeSessions() {
      this.loading= true;

      ProgramService.getcredentials(this.page, 10)
        .then((response) => { 
          this.loading = false;
          this.itensCredentials = response.data.items; 
          this.total = response.data.total 
        },
        () => { 
          this.loading = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        }
      );
       
    },
  },
};
</script>
<style lang="scss">
.dot_vpn{
  position: absolute;
  top: 2px; 
  left: -7px;
}
</style>
 